import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";

import useHasRight from "../../authorization/hooks/useHasRight";

import PricesForm from "../components/PricesForm/PricesForm";

export default function CreatePrices() {
	const { t } = useTranslation();
	const { organization } = useOutletContext();

	const navigate = useNavigate();
	const hasRight = useHasRight();

	if (!hasRight("prices.create")) {
		return false;
	}

	return (
		<>
			<div style={{ marginBottom: 15 }}>
				<Header as="h2">{t("addPrices", "Add prices")}</Header>
			</div>

			<PricesForm organization={organization} afterSubmit={() => navigate("../")} />
		</>
	);
}
